module.exports = __webpack_public_path__ + "static/media/banner001.687f63fd.jpg";